import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

import {
  NewGame,
  Game,
  EndGame,
  NewCard,
  Login,
  MyCards,
  EditCard,
  MyGroups
} from '../pages'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: NewGame
    },
    {
      path: '/new-game',
      name: 'newGame',
      component: NewGame
    },
    {
      path: '/game',
      name: 'game',
      component: Game
    },
    {
      path: '/end-game',
      name: 'endGame',
      component: EndGame
    },
    {
      path: '/new-card',
      name: 'newCard',
      component: NewCard,
      meta: { requiresAuth: true }
    },
    {
      path: '/my-cards',
      name: 'myCards',
      component: MyCards,
      meta: { requiresAuth: true }
    },
    {
      path: '/edit-card/:id',
      name: 'editCard',
      component: EditCard,
      meta: { requiresAuth: true }
    },
    {
      path: '/my-groups',
      name: 'myGroups',
      component: MyGroups,
      meta: { requiresAuth: true }
    },
    {
      path: '/my-profile',
      name: 'myProfile',
      component: MyGroups,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: function (to, from, next) {
        router.app.$store.dispatch('logout').then(() => {
          router.push({ name: 'home' })
        })
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.getLoggedIn) {
      next({
        name: 'login',
        query: {
          redirect: to.name,
          params: JSON.stringify(to.params),
          query: JSON.stringify(to.query)
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js